import axios from 'axios'

  export const hoa_blogs_get_new = input => {
        return axios
            .get('https://www.houseofalpha.in/alpha_user_website/new_hoa_blogs')
            .then(response => {
                return response.data
            })
            .catch(err => {})
      }
export const contact_hoa = input => {
    return axios
        .post('https://www.houseofalpha.in/alpha_user_website/contact_hoa',
        {
            name: input.name,
            surname: input.surname,
            email: input.email,
            phone_number: input.phone_number,
            message: input.message,
            reference:'p2p',
            flag : 'p2p'
        },
        {
            headers: {
              'Authorization': input.access_token
            }
          })
        .then(response => {
            return response.data
        })
        .catch(err => {})
}